module.exports = __webpack_public_path__ + "static/Tuukka_Peuraniemi-5539e3fbb69416ddc3a758c501c189ab.jpg";